/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { SupervisorAxisDto } from '../models';
// @ts-ignore
import type { TeamSupervisorsResultDto } from '../models';
/**
 * TeamSupervisorsApi - axios parameter creator
 * @export
 */
export const TeamSupervisorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zwraca przełożonych z zakresu widoczności wołającego — czyli tych, po których ma sens filtrować listę pracowników i macierz. Lista jest płaska i posortowana od góry struktury w dół; poziom służy wyłącznie do wcięcia i sortowania po stronie klienta, nie jest wartością do pokazania użytkownikowi. 
         * @summary Flat list of supervisors available as a filter value (JAIN-257)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {SupervisorAxisDto} [axis] Oś, wzdłuż której grupujemy ludzi. SUPERVISOR to linia przełożonych, HRBP to przypisanie do opiekuna obszaru. To dwie różne struktury, więc listy nie muszą się pokrywać. Domyślnie SUPERVISOR. 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTeamSupervisors: async (accessType?: EmployeeAccessTypeDto, axis?: SupervisorAxisDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/team/development/supervisors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (axis !== undefined) {
                localVarQueryParameter['axis'] = axis;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamSupervisorsApi - functional programming interface
 * @export
 */
export const TeamSupervisorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamSupervisorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Zwraca przełożonych z zakresu widoczności wołającego — czyli tych, po których ma sens filtrować listę pracowników i macierz. Lista jest płaska i posortowana od góry struktury w dół; poziom służy wyłącznie do wcięcia i sortowania po stronie klienta, nie jest wartością do pokazania użytkownikowi. 
         * @summary Flat list of supervisors available as a filter value (JAIN-257)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {SupervisorAxisDto} [axis] Oś, wzdłuż której grupujemy ludzi. SUPERVISOR to linia przełożonych, HRBP to przypisanie do opiekuna obszaru. To dwie różne struktury, więc listy nie muszą się pokrywać. Domyślnie SUPERVISOR. 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readTeamSupervisors(accessType?: EmployeeAccessTypeDto, axis?: SupervisorAxisDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSupervisorsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readTeamSupervisors(accessType, axis, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSupervisorsApi.readTeamSupervisors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamSupervisorsApi - factory interface
 * @export
 */
export const TeamSupervisorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamSupervisorsApiFp(configuration)
    return {
        /**
         * Zwraca przełożonych z zakresu widoczności wołającego — czyli tych, po których ma sens filtrować listę pracowników i macierz. Lista jest płaska i posortowana od góry struktury w dół; poziom służy wyłącznie do wcięcia i sortowania po stronie klienta, nie jest wartością do pokazania użytkownikowi. 
         * @summary Flat list of supervisors available as a filter value (JAIN-257)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {SupervisorAxisDto} [axis] Oś, wzdłuż której grupujemy ludzi. SUPERVISOR to linia przełożonych, HRBP to przypisanie do opiekuna obszaru. To dwie różne struktury, więc listy nie muszą się pokrywać. Domyślnie SUPERVISOR. 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTeamSupervisors(accessType?: EmployeeAccessTypeDto, axis?: SupervisorAxisDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamSupervisorsResultDto> {
            return localVarFp.readTeamSupervisors(accessType, axis, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamSupervisorsApi - interface
 * @export
 * @interface TeamSupervisorsApi
 */
export interface TeamSupervisorsApiInterface {
    /**
     * Zwraca przełożonych z zakresu widoczności wołającego — czyli tych, po których ma sens filtrować listę pracowników i macierz. Lista jest płaska i posortowana od góry struktury w dół; poziom służy wyłącznie do wcięcia i sortowania po stronie klienta, nie jest wartością do pokazania użytkownikowi. 
     * @summary Flat list of supervisors available as a filter value (JAIN-257)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {SupervisorAxisDto} [axis] Oś, wzdłuż której grupujemy ludzi. SUPERVISOR to linia przełożonych, HRBP to przypisanie do opiekuna obszaru. To dwie różne struktury, więc listy nie muszą się pokrywać. Domyślnie SUPERVISOR. 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamSupervisorsApiInterface
     */
    readTeamSupervisors(accessType?: EmployeeAccessTypeDto, axis?: SupervisorAxisDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamSupervisorsResultDto>;

}

/**
 * TeamSupervisorsApi - object-oriented interface
 * @export
 * @class TeamSupervisorsApi
 * @extends {BaseAPI}
 */
export class TeamSupervisorsApi extends BaseAPI implements TeamSupervisorsApiInterface {
    /**
     * Zwraca przełożonych z zakresu widoczności wołającego — czyli tych, po których ma sens filtrować listę pracowników i macierz. Lista jest płaska i posortowana od góry struktury w dół; poziom służy wyłącznie do wcięcia i sortowania po stronie klienta, nie jest wartością do pokazania użytkownikowi. 
     * @summary Flat list of supervisors available as a filter value (JAIN-257)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {SupervisorAxisDto} [axis] Oś, wzdłuż której grupujemy ludzi. SUPERVISOR to linia przełożonych, HRBP to przypisanie do opiekuna obszaru. To dwie różne struktury, więc listy nie muszą się pokrywać. Domyślnie SUPERVISOR. 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamSupervisorsApi
     */
    public readTeamSupervisors(accessType?: EmployeeAccessTypeDto, axis?: SupervisorAxisDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return TeamSupervisorsApiFp(this.configuration).readTeamSupervisors(accessType, axis, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

